import { createSelector } from 'reselect'
import getPathnameRouterSelect from 'modules/router/selectors/get-pathname/index.js'

export const isWorkoutUrlRouterSelect = createSelector(
  getPathnameRouterSelect,
  (pathname) => /workouts\//gi.test(pathname)
)
